<div *ngIf="isVisible" class="tutorial-overlay">
    <div class="tutorial-container">
        <!-- Pantalla de inicio (Antes de empezar) -->
        <div *ngIf="currentStep === 0" class="tutorial-content">
            <div class="tutorial-header">
                <h2>Antes de empezar</h2>
            </div>
            
            <div class="tutorial-body">
                <h1>VisionBoard</h1>
                
                <p>Es el momento de crear tu Vision Board para definir y visualizar tus metas futuras, aumentando tus posibilidades de éxito. Dedica tiempo a reflexionar y diseñar un plan que te motive. Escribir tus metas mejora la claridad y la motivación personal y profesional.</p>
            </div>
            
            <div class="tutorial-actions">
                <button class="skip-button" (click)="skipTutorial()">Omitir tutorial</button>
                <button class="next-button" (click)="nextStep()">Continuar al tutorial</button>
            </div>
        </div>

        <!-- Paso 1/3: Introducción al Visionboard -->
        <div *ngIf="currentStep === 1" class="tutorial-content">
            <!-- Indicador de paso -->
            <div class="step-indicator">
                {{currentStep}}/{{totalSteps}}
            </div>
            
            <div class="tutorial-header">
                <h1>VisionBoard</h1>
            </div>
            
            <div class="tutorial-body">
                <p>Para ayudarte en la creación de tu Vision Board, reflexiona sobre:</p>
                
                <ul>
                    <li>¿Qué es lo más importante para mí?</li>
                    <li>¿Cuáles son mis valores?</li>
                    <li>¿Qué quiero cambiar?</li>
                    <li>¿Por qué estoy tomando esta decisión?</li>
                    <li>¿Qué dificultades enfrento?</li>
                    <li>¿Qué cualidades me ayudarán a tener éxito?</li>
                    <li>¿Quién puede ayudarme?</li>
                    <li>¿Cómo me veo al alcanzar mi meta?</li>
                </ul>
            </div>
            
            <div class="tutorial-actions">
                <button class="skip-button" (click)="skipTutorial()">Omitir tutorial</button>
                <button class="next-button" (click)="nextStep()">Siguiente</button>
            </div>
        </div>

        <!-- Paso 2/3: Incluye imágenes -->
        <div *ngIf="currentStep === 2" class="tutorial-content">
            <!-- Indicador de paso -->
            <div class="step-indicator">
                {{currentStep}}/{{totalSteps}}
            </div>
            
            <div class="tutorial-header">
                <h1>Incluye imágenes</h1>
            </div>
            
            <div class="tutorial-body">
                <p>Usa tu imaginación y asegúrate de que tu propósito esté alineado con tus visualizaciones.</p>
                <p>Incluye fotos representativas de aspectos importantes de tu vida, como salud, diversión, desarrollo personal, carrera, familia y amigos.</p>
                <p>Puedes usar plataformas como Pinterest e Instagram para encontrar imágenes.</p>
            </div>
            
            <div class="tutorial-actions">
                <button class="skip-button" (click)="skipTutorial()">Omitir tutorial</button>
                <button class="next-button" (click)="nextStep()">Siguiente</button>
            </div>
        </div>

        <!-- Paso 3/3: Finalización -->
        <div *ngIf="currentStep === 3" class="tutorial-content">
            <!-- Indicador de paso -->
            <div class="step-indicator">
                {{currentStep}}/{{totalSteps}}
            </div>
            
            <div class="tutorial-header">
                <h1>VisionBoard</h1>
            </div>
            
            <div class="tutorial-body">
                <p>Una vez creado tu Vision Board, lo revisaremos periódicamente para ajustar tus objetivos y verificar tu progreso. Reflexiona sobre lo que ha funcionado, lo que no, y ajusta tus metas según sea necesario.</p>
                <p>A veces, sentimos que tenemos que hacerlo todo solos, pero no es así. Tienes a la comunidad de Phoenix que te ayudará en este camino.</p>
            </div>
            
            <div class="tutorial-actions">
                <button class="skip-button" (click)="skipTutorial()">Omitir tutorial</button>
                <button class="next-button" (click)="finishTutorial()">Aceptar y empezar</button>
            </div>
        </div>
    </div>
</div> 